import styled from 'styled-components';

export const EmptySettingsFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 30px;
  margin: 10px;
`;

export const FormItem = styled.div`
  flex: 0 0 calc(33.33% - 20px); /* 33.33% width with a little spacing */
`;

export const SubmitContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;
